module.exports = __webpack_public_path__ + "img/role-nini.cacd99b5.png";